<div class="chat-slide-tray" [@openClose]="sidebarState_()">
  <ods-button 
    class="chat-close-btn" 
    variant="primary"
    (click)="toggleSidebar()"
  >    
    <ods-icon slot="icon" variant="carat"/>
  </ods-button>
  <div class="chat-container">
      @if (showLiveChat_()) {
        <iframe class="live-chat" [src]="iframeSrc_()"></iframe>
      }      
      @else {
        <div class="chat-header">Chat</div>
        @if (showLiveChatError_()) {
          <div class="live-chat-error">
            <div>An error occurred while attempting to start a chat session.</div>
            <ods-button class="live-chat-error-retry-btn" (click)="handleRetryClick()">Retry</ods-button>
          </div>
        } 
        @else if (chatAvailable()) {
          <app-chat-questions
            (cancelChatSelected)="toggleSidebar()"
            (chatTokenAcquired)="handleChatTokenAcquired($event)"
          />
        } 
        @else {
          <app-chat-unavailable/>
        }  
      }
  </div>
</div>
@if (showOpenChatBtn_()) {
  <span
    @showHide
    #button
    role="button"
    tabindex="0"
    aria-label="Chat with UPMC Health Plan"
    class="tootltip-wrapper disclaimer-modal-button"
    tooltipDirective
    data="Chat with UPMC Health Plan"
    (click)="openChat()"
    (keydown.enter)="openChat()"
  ></span>
}
